/*
 * @Date: 2019-09-06 14:15:39
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-17 16:34:04
 */
/**
 * loadJs
 * 暴露方法：
 * 1. 检测登录态
 * 2. 登录 -- 返回新老用户标示
 * 3. 修改用户信息方法
 */
import { XesAxios } from '@xes/terra-utils'

const LoginSdk = {
  async init () {
    // sdk版本/滑块注
    /* eslint @typescript-eslint/no-this-alias: 1 */
    // eslint-disable-next-line
    const _this = this
    // 滑块注入
    window.TAL_UC.configNVC({
      renderToEle: '#captcha',
      isH5: false,
      onloadCallback: function () {
        _this.log({
          data: '滑块配置完成'
        })
      },
      failCallback: function () {
        _this.log({
          data: '滑块配置错误'
        })
      }
    })
    // client-id注入
    window.TAL_UC.rankConfig({
      'client-id': '111202' // client-id由平台发放权限码，接入之前向平台申请
    })
    // 检测登录态
    return new Promise((resolve) => {
      const params = {
        success: async function (res) {
          LoginSdk.log({
            event: 'checkLogin-Sdk',
            data: res
          })
          if (res.errcode === 0) {
            // sdk返回登录态，需要继续请求保留token
            const data = {
              code: res.data.code
            }
            // 网校code换取tal_token接口
            const tokenData = {
              code: res.data.code,
              ...data
            }
            await LoginSdk.getToken(tokenData).then(result => {
              resolve(result)
            })
          } else {
            // 无登录态
            const data = {
              stat: res.errcode,
              errmsg: res.errmsg
            }
            resolve(data)
          }
        },
        fail: function (error) {
          const data = {
            stat: 2001,
            errmsg: `checkLogin-Sdk调用失败${error}`
          }
          resolve(data)
        }
      }
      window.TAL_UC.checkToken(params)
    })
  },
  /**
   *
   * @param {*} data
   *  {
        phone: ,    // 地区不同手机号码规则不同
        phone_code: ,    // 手机地区码
        sms_code:     // 短信验证码
    },
   */
  sendCode (data) {
    // 获取验证码
    return new Promise((resolve) => {
      const sendSMSCodeParams = {
        data: {
          ...data,
          verify_type: 2
        },
        success: res => {
          resolve(res)
        },
        fail: error => {
          LoginSdk.log({
            event: 'sendSMSCodeLogin',
            data: error
          })
        }
      }
      window.TAL_UC.sendSMSCodeLogin(sendSMSCodeParams)
    })
  },
  sendCode2 (data) {
    // 获取验证码
    return new Promise((resolve) => {
      const params = {
        data: {
          ...data,
          verify_type: 2
        },
        success: res => {
          resolve(res)
        },
        fail: error => {
          LoginSdk.log({
            event: 'sendSMSCodeLogin',
            data: error
          })
        }
      }
      window.TAL_UC.sendSMSCodeLogin(params)
    })
  },
  /**
   *
   * @param {*} data
   * {
        phone: ,    // 地区不同手机号码规则不同
        phone_code: ,    // 手机地区码
        sms_code:     // 短信验证码
    },
   * @return: {
      "type":1, // 用户当前行为是登录还是注册1：登录、2：注册
      "user_id":"31391", // 用户id
      "tal_token":"tal_token" // 登录态token
   }
   */
  toLogin (data) {
    // 登录
    return new Promise((resolve) => {
      const params = {
        data,
        success: async res => {
          // 登录成功
          resolve(res)
        },
        fail: error => {
          LoginSdk.log({
            event: 'loginSms',
            data: error
          })
        }
      }
      window.TAL_UC.loginSms(params)
    })
  },
  /**
   * 获取登录态
   */
  checkLogin () {
    return new Promise((resolve) => {
      const params = {
        success: async function (res) {
          LoginSdk.log({
            event: 'checkLogin-Sdk',
            data: res
          })
          if (res.errcode === 0) {
            // sdk返回登录态，需要继续请求保留token
            const data = {
              code: res.data.code
            }
            // 网校code换取tal_token接口
            const tokenData = {
              code: res.data.code,
              ...data
            }
            await LoginSdk.getToken(tokenData).then(result => {
              resolve(result.data)
            })
          } else {
            // 无登录态
            const data = {
              stat: res.errcode,
              errmsg: res.errmsg
            }
            resolve(data)
          }
        },
        fail: function (error) {
          const data = {
            stat: 2001,
            errmsg: `checkLogin-Sdk调用失败${error}`
          }
          resolve(data)
        }
      }
      window.TAL_UC.checkToken(params)
    })
  },
  currentTimeString () {
    const timeString =
      '[' +
      ('' + new Date().getHours()).padStart(2, '0') +
      ':' +
      ('' + new Date().getMinutes()).padStart(2, '0') +
      ':' +
      ('' + new Date().getSeconds()).padStart(2, '0') +
      ':' +
      ('' + new Date().getMilliseconds()).padStart(3, '0') +
      ']'
    return timeString
  },
  log (msgbody) {
    msgbody = typeof msgbody === 'string' ? msgbody : JSON.stringify(msgbody)
    console.log(`${this.currentTimeString()}${msgbody}`)
  },
  async getToken (data) {
    // 注意： 参数不支持json格式
    return XesAxios.get('https://login.xueersi.com/LoginV1/getToken', {
      params: data
    })
  }
}

export default LoginSdk
